import { useMutation } from '@tanstack/react-query';

import { message } from 'antd';

import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { GetMappingSettingsParamsDTO } from '@app/models/orders';
import Api from '@app/services/api';

export const usePostGetSettingsMapping = () => {
  const commonT = useTranslation(NSKeys.common);

  return useMutation({
    mutationFn: async (data: GetMappingSettingsParamsDTO) => {
      return await Api.orders.postGetSettingsMapping(data);
    },
    onError: () => {
      message.open({
        type: 'error',
        content: commonT.t('error400'),
      });
    },
    onSuccess: async (data) => {
      return data;
    },
  });
};
